import { KalturaMetaValue } from './composed/KalturaMetaValue';

export function fromKalturaBoolean(meta?: KalturaMetaValue) {
  if (!meta) {
    return false;
  }

  if (meta.objectType === 'KalturaBooleanValue') {
    return meta.value;
  }

  return String(meta.value) === '1' || String(meta.value) === 'true';
}
